import { createServerFn } from "@tanstack/react-start";
import { getDiscovery } from "@/lib/core/discovery-core.server";

export type HeroListing = {
    id: string;
    name: string;
    breed: string;
    image: string;
};

export const getHeroListings = createServerFn({ method: "GET" })
    .inputValidator(() => undefined)
    .handler(async (): Promise<HeroListing[]> => {
        const discovery = await getDiscovery();
        return await discovery.feeds.heroListings();
    });
